<script setup lang="ts">
interface Props {
	size?: string;
}
defineProps<Props>();
</script>
<template>
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fill="#000000"
		height="30"
		width="30"
	>
		<g fill="none" fill-rule="evenodd">
			<circle cx="7" cy="12" r="7" fill="#EA001B"></circle>
			<circle cx="17" cy="12" r="7" fill="#FFA200" fill-opacity=".8"></circle>
		</g>
	</svg>
</template>
